// lib
import PropTypes from 'prop-types'
// import classNames from 'classnames'

// styles
import style from '@aytm/app/stats/page/question-views/components/word-cloud/styles/Payment.module.scss'

const Payment = ({ features }) => {
  return (
    <div className={style.component}>
      {/* PME2 (AYTM-11321): render server-authored `text` verbatim; guard the icon, which the
          already-on-Enterprise Contact-Us variant omits. `id` stays the CSS theme-color hook. */}
      <a
        className={`stat-upgrade-button ${features.word_clouds.onPackage.id}`}
        href={features.word_clouds.onPackage.upgradeURL}
        target="_blank"
        rel="noreferrer"
      >
        {features.word_clouds.onPackage.icon ? (
          <span className="stat-upgrade-icon">
            <i className={`icon-aytmfd-${features.word_clouds.onPackage.icon}`}></i>
          </span>
        ) : null}
        <span className="stat-upgrade-text" dangerouslySetInnerHTML={{ __html: features.word_clouds.onPackage.text }} />
      </a>
    </div>
  )
}

Payment.propTypes = { features: PropTypes.object }

Payment.displayName = 'Payment'

export default Payment
